import React from "react";
import { NavLink, useNavigate } from "react-router";

const MobileNav = ({ menuOpen, setMenuOpen }) => {
  const navigate = useNavigate();
  const logOut = async () => {
    navigate("/login");
    setMenuOpen(false);
  };
  const clickNav = () => {
    setMenuOpen(false);
  };
  if (menuOpen) {
    return (
      <div className="nav_container_mobile">
        <NavLink onClick={clickNav} className="nav_btn_mobile" to={"/alert"}>
          Центр оповещений
        </NavLink>
        <NavLink onClick={clickNav} className="nav_btn_mobile" to={"/home"}>
          Устройства
        </NavLink>
        <NavLink
          onClick={clickNav}
          className="nav_btn_mobile"
          to={"/myprofile"}
        >
          Профиль
        </NavLink>
        <div onClick={logOut} className="nav_btn_mobile">
          Выйти
        </div>
      </div>
    );
  }
};

export default MobileNav;
